// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3MDix","large":"styles_large__1zE4K"};